import { render } from "./UpgradeOption.vue?vue&type=template&id=e13b2d86&scoped=true&ts=true&lang=pug"
import script from "./UpgradeOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpgradeOption.vue?vue&type=script&setup=true&lang=ts"

import "./UpgradeOption.vue?vue&type=style&index=0&id=e13b2d86&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13b2d86"]])

export default __exports__